export default __webpack_public_path__ + "static/media/Q2_3.031dd282.png";